import React, { useState, useRef, useCallback, useEffect } from 'react';
import { ToastCtx } from '../../context';
import { useLang } from '../../i18n';
import { TOAST_MS, TOAST_UNDO_MS } from '../../config/constants';

/**
 * Owns the undo-able toast and hands `notify(message, undo?)` to everything inside via
 * ToastCtx. The toast's state lives HERE, so showing or hiding one re-renders only the
 * toast — not the board it sits on. Render it inside `.do-root` (it uses its colours).
 */
export function ToastHost({ children }) {
  const { t } = useLang();
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  const notify = useCallback((msg, undo) => {
    setToast({ msg, undo });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), undo ? TOAST_UNDO_MS : TOAST_MS);
  }, []);
  useEffect(() => () => clearTimeout(timer.current), []);
  const undo = () => { toast.undo(); setToast(null); };
  return (
    <ToastCtx.Provider value={notify}>
      {children}
      {toast && (
        <div className="do-toast" role="status">
          <span className="do-toast__msg">{toast.msg}</span>
          {toast.undo && <button className="do-toast__undo" onClick={undo}>{t('common.undo')}</button>}
        </div>
      )}
    </ToastCtx.Provider>
  );
}
